import {
  Button,
  Icon,
  Landscape,
} from 'mand-mobile'

const components = {
  [Button.name]: Button,
  [Icon.name]: Icon,
  [Landscape.name]: Landscape,
}

export default function(Vue) {
  Object.keys(components).forEach((key) => {
    Vue.component(components[key].name, components[key])
  })
}
